export default __webpack_public_path__ + "static/media/hm.fa2bc1f3.jpg";